/* eslint-disable import/prefer-default-export */
import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL}`;

// interview-panel头部数据
export async function getInterviewGroup(id) {
  return client.post({
    url: `${url}/admin/interview_group_time/get_detail`,
    form: {
      id,
    },
  });
}
// interview-pannel内容列表数据
export async function getPhaseTaskList({ phaseId, timeId }) {
  return client.post({
    url: `${url}/phase_task/get_list`,
    form: {
      time_id: timeId,
      phase_id: phaseId,
    },
  });
}
